import { ArrowUpRight } from "lucide-react";
import { RECONCILIATION } from "../../data/content";
import { Reveal } from "./Reveal";

const CHARTER = [
  ["01", "Learn"],
  ["02", "Be believed"],
  ["03", "Begin again"],
];

export default function Reconciliation() {
  return (
    <section
      id="reconciliation"
      data-testid="reconciliation-section"
      className="bg-[#0f1e36]"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-24 md:px-10 md:py-36">
        <Reveal>
          <div className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.28em] text-[#cbb890]">
            <span className="h-px w-10 bg-[#cbb890]/60" />
            {RECONCILIATION.eyebrow}
          </div>
        </Reveal>

        <div className="mt-12 grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Reveal delay={0.08}>
              <h2 className="font-display text-5xl font-light leading-[1.02] tracking-tight text-[#f8fafc] md:text-7xl">
                {RECONCILIATION.title}
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-[#aab4c8] md:text-lg">
                {RECONCILIATION.body}
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <a
                href={RECONCILIATION.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reconciliation-cta"
                className="group mt-10 inline-flex items-center gap-3 rounded-full bg-[#cbb890] px-8 py-4 text-sm uppercase tracking-[0.14em] text-[#0f1e36] transition-colors duration-300 hover:bg-[#f8fafc]"
              >
                {RECONCILIATION.cta}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
            </Reveal>
          </div>

          {/* Charter */}
          <div className="lg:col-span-4">
            <Reveal delay={0.16}>
              <div className="border-l border-white/15 pl-8">
                {CHARTER.map(([n, label], i) => (
                  <div
                    key={n}
                    className={`flex items-baseline gap-5 py-5 ${
                      i === CHARTER.length - 1 ? "" : "border-b border-white/10"
                    }`}
                  >
                    <span className="font-mono text-xs text-[#cbb890]">{n}</span>
                    <span className="font-display text-2xl text-[#f8fafc]">{label}</span>
                  </div>
                ))}
                <p className="mt-8 font-mono text-[10px] uppercase leading-loose tracking-[0.18em] text-[#8b95ab]">
                  An education &amp; advocacy hub for survivors of sexual assault
                  and reproductive coercion
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
